import { render } from "./NavLinkComp.vue?vue&type=template&id=0999698b&scoped=true&ts=true"
import script from "./NavLinkComp.vue?vue&type=script&lang=ts"
export * from "./NavLinkComp.vue?vue&type=script&lang=ts"

import "./NavLinkComp.vue?vue&type=style&index=0&id=0999698b&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\user\\Documents\\Code\\VSProjects\\modboxProject\\modbox\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0999698b"]])

export default __exports__